import React from 'react';
import PropTypes from 'prop-types';
import {SortDirections} from '../../../api/consts';
import {sortIcon, sortUpIcon} from '../../../assets/images/buttons/index';

function SMCTableHeaderColumn({
    column,
    width,
    sortBasis,
    sortDirection,
    setSort,
    className
}) {
    return (
        <td
            key={column.id}
            align={column.align || "left"}
            style={{ width: width || column.width, cursor: column.sort ? 'pointer' : 'default' }}
            className={className}
            onClick={column.sort ? (() => setSort(column.id)) : undefined}
        >
            <span title={column.header}>
                {
                    column.header || <>&nbsp;</>
                }
                {
                    column.sort && (
                        sortBasis === column.id && (
                            <div style={{ position: 'relative' }}>
                                <div style={{ position: 'absolute', right: '2px', bottom: '-2px' }}>
                                    <div style={{ float: 'right', flexDirection: 'column' }}>                                    
                                        <img alt="" src={sortDirection === SortDirections.ASCENDING ? sortUpIcon : sortIcon}  style={{  top: '50%', transform: 'translateY(-50%)' }}/>
                                    </div>
                                </div>
                            </div>
                        )
                    )
                }
            </span>
        </td>
    );
}

SMCTableHeaderColumn.propTypes = {
    column: PropTypes.object.isRequired,
    width: PropTypes.number,
    sortBasis: PropTypes.string,
    setSort: PropTypes.func,
    sortDirection: PropTypes.string
}

export default React.memo(SMCTableHeaderColumn);